import React, { useEffect, useRef, useState } from 'react'
import { t } from '../i18n'
import { useUi } from '../State/Ui'
import { ArrowLeft } from './Icons'
import { useBack } from './PageHeader'

const COMPACT_HEIGHT = 52 // keep in sync with --header-h in Styles/index.scss
const APP_BAR_HEIGHT = 60 // --app-bar-h, mobile web only

/* Header of topic, source, category and search pages (spec 5.6). At the top:
   back, the big name (22 px), "+ Prati", and `children` (the category's
   "Teme" row). Once that scrolls away a thin bar takes its place: back, the
   name (17 px, cut short), a small follow button. The sticky tabs sit under
   the bar, so the top never holds more than bar + tabs. The bar floats over
   the page instead of joining it, so nothing jumps when it appears. */
export default function CollapsingHeader({
  title,
  avatar = null,
  action = null,
  compactAction = null,
  children,
}) {
  const back = useBack()
  const { isMobile } = useUi()
  const sentinel = useRef(null)
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    const el = sentinel.current
    if (!el) return undefined
    const top = (isMobile ? APP_BAR_HEIGHT : 0) + COMPACT_HEIGHT
    const io = new IntersectionObserver(
      ([entry]) => setCollapsed(!entry.isIntersecting && entry.boundingClientRect.top < top),
      { rootMargin: `-${top}px 0px 0px 0px` }
    )
    io.observe(el)
    return () => io.disconnect()
  }, [isMobile])

  return (
    <>
      <div className="compact-anchor">
        <div className={`compact-bar ${collapsed ? 'shown' : ''}`} aria-hidden={!collapsed}>
          <button
            type="button"
            className="icon-button back-button"
            aria-label={t('common.back')}
            onClick={back}
          >
            <ArrowLeft size={22} />
          </button>
          <span className="compact-title">{title}</span>
          {compactAction}
        </div>
      </div>
      <header className="full-header">
        <div className="full-header-top">
          <button
            type="button"
            className="icon-button back-button"
            aria-label={t('common.back')}
            onClick={back}
          >
            <ArrowLeft size={22} />
          </button>
          {avatar}
          <h1 className="full-title">{title}</h1>
          {action && <div className="page-header-action">{action}</div>}
        </div>
        {children}
        <div ref={sentinel} className="full-header-end" aria-hidden="true" />
      </header>
    </>
  )
}
